import React from 'react';
import { Plugin, CustomEditor } from '../types';

const ChecklistPlugin: Plugin = {
  name: 'checklist',
  
  commands: {
    insertChecklist: (editor: CustomEditor, checked: boolean = false) => {
      // TODO: Implement checklist insertion
      console.log('Insert checklist:', checked);
    }
  }
};

export default ChecklistPlugin; 